
export default {
  namespaced: true,
  state: {
    time: new Date()
  },
  mutations: {
    SET_TIME(state, time) {
      state.time = time
    }
  }
}